import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShortlistFormModal from '../Shortlists/ShortlistFormModal';
import DeleteShortlistModal from '../Shortlists/DeleteShortListModal';
import { OverflowMenu, MENU_ICONS as ICONS } from '../../../components/MenuOptions/OverflowMenu';

interface Props {
  shortlist: any;
  fetchShortlists: () => void;
}

const VideoShortlistCardMenu = ({ shortlist, fetchShortlists }: Props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const navigate = useNavigate();

  const share = () => {
    if (!shortlist?.id) return;
    window.open(`/videos/shortlists/share/${shortlist.id}`, '_blank');
  };

  if (!shortlist) return null;

  const groups = [
    {
      label: 'Get',
      items: [
        { key: 'view', label: 'View', icon: ICONS.view, onClick: () => navigate(`/videos/shortlists/${shortlist.id}`) },
        { key: 'share', label: 'Share URL', icon: ICONS.share, onClick: share },
      ],
    },
    {
      label: 'Edit',
      items: [
        { key: 'edit', label: 'Edit', icon: ICONS.edit, onClick: () => setEditModalOpen(true) },
        { key: 'duplicate', label: 'Duplicate', icon: ICONS.duplicate, onClick: () => setDuplicateModalOpen(true) },
      ],
    },
    {
      label: '',
      items: [
        { key: 'delete', label: 'Delete', icon: ICONS.trash, danger: true, onClick: () => setDeleteModalOpen(true) },
      ],
    },
  ];

  return (
    <>
      <OverflowMenu groups={groups} ariaLabel="Shortlist actions" width={230} />

      {editModalOpen && (
        <ShortlistFormModal
          mode="edit"
          open={editModalOpen}
          setOpen={setEditModalOpen}
          shortlistId={shortlist.id}
          currentName={shortlist.name}
          fetchShortlists={fetchShortlists}
          updateShortlistName={() => {}}
          apiBase="/video-shortlists"
          label="Video Shortlist"
          currentDownloadEnabled={shortlist.download_enabled ?? true}
          onDownloadEnabledChange={(enabled) => { shortlist.download_enabled = enabled; }}
        />
      )}

      {deleteModalOpen && (
        <DeleteShortlistModal
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          shortlistId={shortlist.id}
          fetchShortlists={fetchShortlists}
          apiBase="/video-shortlists"
          label="Video Shortlist"
        />
      )}

      {duplicateModalOpen && (
        <ShortlistFormModal
          mode="duplicate"
          open={duplicateModalOpen}
          setOpen={setDuplicateModalOpen}
          shortlistId={shortlist.id}
          currentName={shortlist.name}
          onShortlistCreated={fetchShortlists}
          apiBase="/video-shortlists"
          label="Video Shortlist"
        />
      )}
    </>
  );
};

export default VideoShortlistCardMenu;
